
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trade/spot/[symbol]",
      function () {
        return require("private-next-pages/trade/spot/[symbol].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trade/spot/[symbol]"])
      });
    }
  